{
  "alerts": {
    "cantCreateProperty": "Feil, klarte ikke oppdatere informasjonen om eiendommen. Prøv igjen senere",
    "cantCreateUser": "Feil, klarte ikke opprette bruker. Prøv igjen senere",
    "cantCancelReservation": "Feil, reservasjonen kunne ikke avbestilles. Prøv igjen senere.",
    "cantCancelSubscription": "Feil, abonnementet kunne ikke kanselleres. Prøv igjen senere.",
    "cantUpdate": "Feil, klarte ikke å oppdatere informasjonen. Prøv igjen senere.",
    "cantUpdateReservtion": "Feil, klarte ikke å oppdatere reservasjonen. Prøv igjen senere eller ta kontakt med oss.",
    "emailIsIncorrect": "E-postadressen er feil. Sørg for at den innskrevne adressen er riktig stavet",
    "googlePlayServicesNotAvailable": "Google Play Services er ikke tilgjengelig på enheten din.",
    "locationNotEnabledDescription": "Du må aktivere stedstjenester for å kunne fullføre bestillinger.",
    "locationNotEnabledTitle": "Aktiver stedstjenester",
    "mandatoryUpdateMessage": "Det er tilgjengelig en obligatorisk oppdatering som må installeres.",
    "outdatedPaymentMethod": "Den valgte betalingsmetoden er utdatert. Oppdater betalingsmetoden og prøv igjen.",
    "paymentFailed": "Det oppsto en feil under betalingen.\nKontakt support eller prøv igjen.",
    "sthWentWrong": "Feil, noe gikk galt.\nKontakt support eller prøv igjen.",
    "unavailableLocalization": "Din lokalisering er ennå ikke tilgjengelig",
    "update": "Oppdater",
    "updateTitle": "Tilgjengelig oppdatering",
    "userWithEmailAlreadyExists": "Bruker med denne e-postadressen finnes allerede"
  },
  "common": {
    "accept": "Godta",
    "add": "Legg til",
    "added": "Lagt til",
    "at": "kl.",
    "cancel": "Avbryt",
    "chat": "Chat",
    "change": "Endre",
    "choose": "Velg",
    "choosePhoto": "Velg bilde",
    "chosen": "Valgt",
    "clear": "Tøm",
    "close": "Lukk",
    "closePage": "Lukk siden",
    "continue": "Fortsett",
    "date": "Dato",
    "default": "Standard",
    "delete": "Slett",
    "deleteService": "Slett %{service}",
    "details": "detaljer",
    "discount": "Rabatt",
    "done": "Ferdig",
    "edit": "Rediger",
    "error": "Feil",
    "email": "E-post",
    "from": "Fra",
    "goBack": "Gå tilbake",
    "help": "Hjelp",
    "hi": "Hei! 👋",
    "hours": "timer",
    "id": "ID",
    "menu": "Meny",
    "name": "Navn",
    "no": "Nei",
    "OK": "OK",
    "or": "Eller",
    "order": "Bestilling",
    "phone": "Telefonnummer",
    "popular": "Populær",
    "price": "Pris",
    "return": "Tilbake",
    "save": "Lagre",
    "service": "Tjeneste",
    "skip": "Hopp over",
    "stripe": "Stripe",
    "takePhoto": "Ta bilde",
    "time": "Tid",
    "together": "Sammen",
    "tryAgain": "Prøv igjen",
    "understand": "Jeg forstår",
    "update": "Oppdater",
    "whether": "Enten",
    "yes": "Ja"
  },
  "components": {
    "drawer": {
      "aboutStepapp": "Om Stephome",
      "coupons": "Kuponger",
      "covid19": "Vår respons på Covid-19",
      "covid19Response": "Respons på Covid-19",
      "downloadApp": "Last ned appen",
      "help": "Hjelp",
      "hey": "Hei! ",
      "heyYou": "Hei %{name}!",
      "payments": "Betalingsmetoder",
      "referAFriend": "Inviter en venn",
      "settings": "Innstillinger",
      "showProfile": "Vis profil",
      "support": "Kundestøtte",
      "writeToUs": "Skriv til oss"
    },
    "footer": {
      "about": "Om oss",
      "app": "App",
      "blog": "Blogg",
      "cancellationRules": "Avbestillingsregler",
      "cleaningPersonnel": "Rengjøringspersonell",
      "contact": "Kontakt oss",
      "contactHours": "Man-lør 9:30-18:00",
      "cookies": "Vi bruker informasjonskapsler for at nettsiden vår skal fungere riktig.",
      "daysAgo": "dager siden",
      "disclaimerPL": "Stepapp til Stepapp sp. z.o.o. registrert i Warszawa. Registrert i National Court Register under nummer 0000896336. NIP: 5252860294.",
      "disclaimerNO": "Stephome AS registrert i Oslo.",
      "FAQ": "Ofte stilte spørsmål",
      "learnMore": "Lær mer",
      "myths": "Myter om rengjøring",
      "privacyPolicy": "Personvern",
      "reviews": "Anmeldelser av Stephome",
      "safePayment": "Sikker betaling",
      "termsOfUse": "Bruksvilkår",
      "today": "i dag",
      "workers": "Renholdsarbeidere",
      "worthKnowing": "Verdt å vite",
      "yesterday": "i går"
    },
    "header": {
      "aboutStepapp": "Om Stephome",
      "coupons": "Kuponger",
      "help": "Hjelp",
      "inviteFriends": "Inviter venner",
      "payments": "Betalingsmetoder",
      "profile": "Profil",
      "register": "Registrering",
      "services": "Tjenester",
      "settings": "Innstillinger",
      "showProfile": "Vis profil",
      "signIn": "Logg inn",
      "support": "Support",
      "writeToUs": "Skriv til oss"
    },
    "input": {
      "placeholder": {
        "additionalInstructions": "Eksempel: Vennligst bank på døren i stedet for å bruke dørklokken.",
        "addNote": "Legg til en notat (valgfritt)",
        "addressFirstLine": "Adresse 1. linje",
        "addressSecond": "Andre adresselinje",
        "addressSecondLine": "Adresse 2. linje",
        "apartmentNumber": "Leilighet",
        "city": "By",
        "companyName": "Firmanavn",
        "doorCode": "Portkode",
        "email": "E-post",
        "firstName": "Fornavn",
        "homeDescription": "F.eks. hva du vil vi skal legge merke til ved rengjøringen?",
        "housing": "Boligområde",
        "keyInfo": "Hvor vil du legge igjen nøkkelen? F.eks. 'Nøkkelen vil være under den lilla blomsterpotten til venstre for døren'",
        "lastName": "Etternavn",
        "NIPNumber": "NIP-nummer",
        "postalCode": "Postnummer",
        "propertyName": "Eiendomsnavn",
        "size": "Størrelse",
        "street": "Gate",
        "typeAddress": "Skriv inn adressen"
      }
    },
    "houseAreaOutOfScope": {
      "houseAreaIsTooLarge": "Det oppgitte arealet på huset er for stort.",
      "orderForLargerHouseArea": "Vil du bestille rengjøring for et større område? Kontakt oss!",
      "writeAndOrderCustomCleaning": "Jeg vil bestille tilpasset rengjøring"
    },
    "paymentOptions": {
      "type_apple": "Apple Pay",
      "type_google": "Google Pay"
    },
    "shareCouponSheet": {
      "copy": "Kopier",
      "description": "Få %{providerReward} for hver venn du refererer som bestiller sin første tjeneste. De får %{receiverReward} bare for å registrere seg fra deg!",
      "discountExplanation": "Minimum bestillingsverdi - 100 kr.",
      "share": "Del",
      "shareMessage": "Jeg sender deg %{codeValue} rabatt på din første rengjøring i Stephome-applikasjonen. For å bruke det, skriv inn koden %{referralCode} når du legger inn en bestilling! \nLink for å legge inn en bestilling: %{appUrl}",
      "title": "Gode venner gir Stephome"
    },
    "tabBar": {
      "application": "Søknad",
      "calendar": "Kalender",
      "dashboard": "Dashbord",
      "myHome": "Mitt hjem",
      "openApp": "Åpne appen",
      "stepappApp": "Stephome-App",
      "stepappAppDescription": "Last ned vår mobilapp for å holde deg oppdatert med bestillingene dine og ikke gå glipp av kampanjer og meldinger fra kundeservice!",
      "stepappMobileApp": "Stephome mobilapp"
    },
    "tabBar_Calendar": "Kalender",
    "tabBar_Dashboard": "Bestill",
    "tabBar_MyHome": "Mine adresser"
  },
  "dialogs": {
    "couponActivated": "Kampanjekoden er aktivert",
    "couponAdded": "Stephome-lommeboken er påfylt med %{amount}",
    "couponCreditsAdded": "Din lommebok er fylt med nye kreditter som kan brukes i Stephome-applikasjonen.",
    "couponFindOtherAndTryAgain": "Eller den er ugyldig. Sjekk for skrivefeil og prøv å legge den inn på nytt.",
    "couponInvalid": "Koden \"%{coupon}\" er ugyldig eller utdatert",
    "couponUsed": "Koden er allerede brukt",
    "later": "Senere",
    "multiPersonServiceInfoMessage": "Husk at én reservasjon er tildelt én tjenesteyter. Hvis du bestiller en tjeneste for mer enn én person, vil den samme personen utføre tjenestene etter hverandre. Hvis du ønsker tjenester for to personer samtidig, må du legge inn to separate bestillinger og nevne dette i notatene til bestillingen.",
    "multiPersonServiceInfoTitle": "Informasjon om tjenester for mer enn én person",
    "negativeRateTitle": "Fortell oss hva vi kan endre eller forbedre. Dette vil hjelpe oss veldig!",
    "ofCourse": "Selvfølgelig",
    "positiveRateTitle": "Supert! 🤘 Vennligst vurder vår\napp. Vi vil være veldig\ntakknemlige!",
    "rateTitle": "Likte du\nStephome-applikasjonen?"
  },
  "notifications": {
    "accountDeletion": {
      "description": "Vi har startet prosessen med å slette kontoen din. Dette kan ta opptil 7 dager.",
      "title": "Kontoen din blir slettet"
    },
    "permissionDenied": {
      "camera": "Du har ikke tillatelse til å bruke kameraet.",
      "cameraDescription": "Gå til appinnstillinger for å tillate bruk av kameraet.",
      "notifications": "Aktiver varsler i appinnstillingene",
      "notificationsDescription": "Vi bruker varsler for å gi deg oppdateringer knyttet til bestillingene dine. Uten å aktivere dem kan appen fungere feil."
    }
  },
  "pages": {
    "auth": {
      "basicInfoDescription": "Vi ber bare om nødvendige opplysninger.\nE-postadressen din og etternavnet ditt vil kun være synlig for oss.",
      "registerInStepapp": "Registrer deg i Stephome."
    },
    "chooseCard": {
      "addCard": "Legg til kort",
      "addCardFailed": "Kortet kunne ikke legges til",
      "addCardFailedDescription": "Sjekk de oppgitte dataene eller prøv igjen senere",
      "cardRecurringPaymentsInfo": "Kortet ditt vil bli knyttet til Stephome-kontoen din og brukt til gjentatte trekk i abonnementet. Du kan alltid endre det i innstillingene.",
      "cardNotSupportThisPayment": "Kortet ditt støtter ikke denne typen betaling. Prøv å legge til et annet kort.",
      "chooseCard": "Velg kort",
      "confirm": "Bekreft",
      "newCard": "Nytt kort"
    },
    "serviceDateAndAddress": {
      "addAddress": "Legg til adresse",
      "addAddressDescription_cleaning": "Gi detaljert informasjon slik at vi kan starte rengjøringen uten problemer.",
      "addAddressDescription_massage": "Gi detaljerte opplysninger slik at vi kan starte masseren uten problemer.",
      "addAddressDescription_other": "Gi detaljerte opplysninger slik at vi kan starte tjenesten uten problemer.",
      "additionalInfo": "Tilleggsinformasjon",
      "addressForm": {
        "address": "Gate og husnummer",
        "addressSecond": "Andre adresselinje",
        "city": "By",
        "doorCode": "Dørkode",
        "iWillBeThere": "Jeg vil være der",
        "iWillLeaveTheKey": "Jeg vil legge igjen nøkkelen",
        "numberOrHousing": "Leilighetsnummer",
        "postalCode": "Postnummer"
      },
      "chooseHour": "Velg time",
      "continueLabel": "Fortsett - Oppsummering og betaling",
      "description": "Velg dato og tidspunkt for tjenesten",
      "howAreWeGoingToEnter": "Hvordan skal vi komme inn i leiligheten din?",
      "howAreWeGoingToEnterDescription": "Dette er valgfri informasjon som vil hjelpe oss med å utføre rengjøringen uten problemer. Du kan alltid legge til dette senere.",
      "instructionsForArrival": "Instruksjoner for ankomst",
      "iWillBeThere": "Jeg vil være der",
      "iWillLeaveTheKey": "Jeg vil legge igjen nøkkelen",
      "provideAddress": "Skriv inn adressen",
      "provideAddressTitle": "Skriv inn adressen for tjenestelevering",
      "provideAddressToCheckAvailability": "Ved å oppgi adressen vil vi kunne fastslå tilgjengeligheten av våre tjenester",
      "title": "Når starter vi?"
    },
    "serviceSummary": {
      "addCard": "Legg til kort",
      "additionalServices": "Tilleggstjenester",
      "address": "Adresse",
      "cancellationRules": "Avbestillingsregler",
      "cancellationRulesDescription": "Avbryt reservasjonen før %{date} for å unngå ekstra kostnader. Avbestilling etter denne tiden vil medføre ekstra kostnader opptil 50% av ordreverdien.",
      "cardDescription": "Vi vil bare reservere midlene 48 timer før rengjøringen. Fakturering vil imidlertid skje på selve rengjøringsdagen.",
      "couponList": "Kupongliste",
      "dateNotAvailable": "Datoen du har valgt er allerede utilgjengelig. Gå tilbake til kalenderen og velg en ny rengjøringsdato.",
      "description": "Gå gjennom bestillingen din igjen og sjekk om alt stemmer",
      "doYouNeedVATInvoice": "Trenger du MVA-faktura?",
      "enterCoupon": "Skriv inn kupong",
      "haveCoupon": "Har du en kupong?",
      "haveCouponDescription": "Du kan legge til kupongen etter at du har logget inn eller registrert deg.",
      "howAreWeGoingToEnter": "Hvordan skal vi komme inn i leiligheten din?",
      "instantPaymentCardDescription": "Hele beløpet vil bli trukket umiddelbart etter bestilling, da det er mindre enn 48 timer igjen til bestillingen din.",
      "instantPaymentInfo": "Midlene vil bli trukket fra kortet ditt umiddelbart, siden det er mindre enn 48 timer igjen til tjenesten starter.",
      "instantPaymentRules": "Din reservasjon vil starte tidligere enn 48 timer. Avbestilling etter denne tiden vil medføre ekstra kostnader opptil 50% av ordreverdien.",
      "invoiceAdditionalEmail": "Du kan legge til en ekstra e-postadresse her for fakturautsendelse. Hvis du lar feltet stå tomt, sender vi fakturaen til e-postadressen tilknyttet kontoen din.",
      "invoiceBeforeSubmit": "Du kan bare gjøre dette før du sender inn bestillingen.",
      "loginToViewDetails": "Logg inn eller registrer deg for å legge inn bestillingen",
      "nextSteps": "Neste steg",
      "nextStepsDescription_cleaning": "Etter at du har bestilt, vil vi tildele en av våre fantastiske rengjøringsdamer tilgjengelig i ditt område. Du vil bli kjent med henne i appen før rengjøringen starter.",
      "nextStepsDescription_massage": "Etter at du har bestilt, vil vi tildele en av våre massasjeterapeuter som er tilgjengelig i ditt område. Du blir kjent med vedkommende i appen før masseren starter.",
      "nextStepsDescription_other": "Etter at du har bestilt, vil vi tildele en av våre ansatte som er tilgjengelig i ditt område. Du blir kjent med vedkommende i appen før tjenesten starter.",
      "pay_blik": "Betal med BLIK",
      "pay_przelewy24": "Betal med Przelewy24",
      "payNow": "Betal nå",
      "payNowDescription": "Husk at ved regelmessig rengjøring vil vi be deg om å legge til et kort for regelmessige rengjøringer. Du kan imidlertid fortsatt betale for første rengjøring med BLIK eller Przelewy24. Dessverre aksepterer vi ikke kontantbetaling.",
      "SMSInfo": "Vi vil sende en SMS-kode til det angitte telefonnummeret. Skriv den inn for å bekrefte pålogging eller registrering.",
      "startDate": "Startdato",
      "title": "Oppsummering",
      "total": "Totalt å betale",
      "VATInvoice": "Fakturainformasjon",
      "VATInvoiceInfo": "Du kan legge til fakturainformasjonen nederst på bestillingen. Husk å gjøre dette <b> før du legger inn bestillingen </b>.",
      "wantToGetVATInvoice": "Jeg ønsker å motta faktura med MVA",
      "yourStepappWallet": "Din Stephome-lommebok"
    }
  },
  "screens": {
    "accommodation": {
      "description": "Vi trenger å vite hva slags bolig du har for å sikre den beste opplevelsen i Stephome",
      "title": "Hvor bor du?",
      "type_APARTMENT": "I en leilighet",
      "type_HOUSE": "I et hus"
    },
    "appUpdate": {
      "description": "Vi har nettopp lansert en ny, lenge etterlengtet oppdatering av systemet og appen vår. Det har vært mange endringer, men nedenfor presenterer vi de viktigste:",
      "feature1": "[Ny] Mulighet til å redigere reservasjoner fra appnivå, legge til nye tjenester.",
      "feature2": "[Ny] Mulighet til å endre dato fra appnivå.",
      "feature3": "[Nye] Smart tilgjengelighetskalender",
      "feature4": "[Nye] Apple Pay / Google Pay-betalinger.",
      "feature5": "[Nye] Enklere betalingshåndtering.",
      "title": "Hei! Velkommen til Stephome 2.0."
    },
    "auth": {
      "alreadyHaveAccount": "Har du allerede en konto?",
      "iHaveAccount": "Jeg har allerede en konto",
      "inWhichCity": "I hvilken by vil du sjekke våre tjenester?",
      "letsStart": "La oss begynne",
      "logIn": "Logg inn",
      "logInWith": "Logg inn med %{provider}",
      "order": "Bestill tjeneste",
      "register": "Registrer deg",
      "welcomeMessage": "Vi vil hjelpe deg med husarbeidet, slik at du får mer fritid hver dag!",
      "welcomeMessage1": "Vi vil hjelpe deg med hjemmepliktene dine, slik at du får",
      "welcomeMessage2": "mer fritid",
      "welcomeMessage3": "hver dag!",
      "whereDoYouLive": "Hvor bor du?"
    },
    "bookedServices": {
      "downloadApp": "Last ned Stephome",
      "emptyBookings": "Du har ingen planlagte tjenester. Bestill en tjeneste på Stephome og sett hjemmet ditt på autopilot!",
      "order": "Bestill Tjeneste",
      "showCompleted": "Vis Fullførte",
      "toTrackProgress": "for å følge fremdriften av reservasjonene dine i sanntid."
    },
    "calendar": {
      "additionalCardVerification": "Kanskje kortet ditt krever ekstra verifisering.",
      "cantFindDate": "Ser du ikke en passende dato?",
      "failedCardPayment": "Vi klarte ikke å belaste kortet ditt",
      "hide": "Skjul",
      "notRegistered": "Her, som en registrert bruker, vil du kunne se dine kommende reservasjoner.",
      "paymentFailed": "Betalingen mislyktes",
      "paymentFailedDescription": "Oppdater betalingsmetoden for å unngå å skape gjeld",
      "serviceScheduleInfo": "Vi viser bare de nærmeste planlagte avtalene. Senere avtaler vil vises etter at tjenesten er fullført. Hvis du vil gjøre endringer i senere avtaler,",
      "settlePayment": "Gjør opp betalingen",
      "showLaterReservations": "Vis senere reservasjoner",
      "title": "Mine Reservasjoner",
      "updatePayment": "Oppdater betalingsmetoden",
      "writeToUs": "skriv til oss."
    },
    "cancelReservation": {
      "addDiscount": "Legg det til i lommeboken din under 'Betalinger', så blir betalingen for neste tjeneste i denne reservasjonen redusert med %{discount}.",
      "cancelAllScheduledAppointments": "Vi vil kansellere alle planlagte avtaler fra dette abonnementet.",
      "cancelAppointment": "Kanseller denne avtalen %{fee}",
      "cancelEntireSubscription": "Kanseller hele abonnementet %{fee}",
      "cancelReservation": "Kanseller reservasjonen",
      "cancelSubscription": "Kanseller abonnement %{fee}",
      "cancelSingleReservationInSubscription": "Du avbestiller bare én enkelt avtale (%{date}). En ny avtale vil bli generert i henhold til abonnementsfrekvensen din.",
      "cancelSubscriptionWithCost": "Du kan også kansellere hele abonnementet, men du vil fortsatt bli belastet for avbestillingen av denne avtalen.",
      "cancelOrEditReservation": "Du kan avbestille hele reservasjonen eller endre datoen.",
      "confirmCancelReservation": "Avbestill denne avtalen %{fee}",
      "confirmCancelSubscription": "Avbestill abonnementet %{fee}",
      "dontCancelAppointment": "Jeg vil ikke avbestille avtalen",
      "dontCancelSubscription": "Jeg vil ikke avbestille abonnementet",
      "insteadOfPaying": "I stedet for å betale %{fee}, kan du spare %{discount}!",
      "maybeConsiderResubscribe": "Kanskje du vil vurdere å abonnere igjen?",
      "newAddressDiscount": "Bestill rengjøring på en ny adresse med rabatt.",
      "nextServiceDiscount": "-%{discount} på neste tjeneste.",
      "reservationCanceled": "Reservasjonen ble kansellert.",
      "serviceCancellation": "Avbestilling av tjeneste.",
      "specialOffer": "Vi har forberedt et spesialtilbud for deg.",
      "staySubscribed": "Forbli abonnent og benytt deg av tilbudet",
      "subscriptionCanceled": "Abonnementet ble kansellert.",
      "weWantToImprove": "Vi ønsker alltid å bli bedre, og din mening betyr noe.",
      "whyCancelReservation": "Hvorfor vil du kansellere reservasjonen?",
      "whyCancelSubscription": "Hvorfor vil du kansellere abonnementet?",
      "cancelCause": {
        "haveBetterOffer": "Jeg har et bedre tilbud",
        "movingToANewPlace": "Jeg flytter til et nytt sted",
        "noLongerNeedTheService": "Jeg trenger ikke lenger tjenestene",
        "other": "Annet",
        "problemWithPlatform": "Jeg har et problem med Stepapp-plattformen",
        "problemWithWorker": "Jeg har et problem med den tildelte personen",
        "serviceNotGoodEnough": "Tjenesten oppfyller ikke mine forventninger"
      }
    },
    "chat": {
      "writeMessage": "Skriv melding"
    },
    "completedServices": {
      "completed": "Fullført",
      "emptyCompleted": "Du har ingen fullførte tjenester. Bestill en tjeneste på Stephome og sett hjemmet ditt på autopilot!",
      "title": "Fullførte bestillinger"
    },
    "coupons": {
      "addCoupons": "Legg til i bestillingen",
      "description": "Har du en rabattkode eller Stephome lommebokskode?",
      "emptyCoupons": "Du har ingen tilgjengelige kuponger",
      "giveAndReceiveDiscount": "Gi 40 NOK, Få 40 NOK",
      "removeCoupons": "Fjern fra bestillingen",
      "shareMailSubject": "Stephome",
      "shareMessage": "Hei! Jeg har 40 NOK gratis for deg i Stephome! %{voucherCode}",
      "title": "Kuponger",
      "typeCode": "Skriv inn koden",
      "validTo": "Gyldig til %{date}",
      "walletFundsDescription": "Midlene i lommeboken vil bli brukt til å betale for neste tjeneste.",
      "yourDiscounts": "Dine rabatter"
    },
    "dashboard": {
      "articlesTitle": "Stephome Blogg",
      "bookNow": "Bestill nå",
      "chooseCategory": "Velg kategori",
      "chooseCity": "Velg by",
      "couldntProcessPayment": "Vi kunne ikke behandle betalingen for rengjøring",
      "hygiene": "Hygiene",
      "hygieneDescription": "Vi har strenge hygienekrav og null toleranse for å bryte sikkerhetsregler.",
      "insurance": "Ansvarsforsikring",
      "insuranceDescription": "Hver bestilling i Stepapp er dekket av en ansvarsforsikring på 1 000 000 zł.",
      "liabilityInsurance": "Ansvarsforsikring opptil 1 million zł",
      "mostPopularServices": "Mest populære tjenester",
      "proposeCity": "Foreslå by",
      "reliability": "Pålitelighet",
      "reliabilityDescription": "Vi sjekker bakgrunnen og erfaringen til alle personer som kommer inn i våre kundes hus.",
      "reviewsWithRating": "%{reviews} anmeldelser med et gjennomsnitt på %{rating}/5",
      "secureOnlineBooking": "Sikker online booking",
      "seeAllReviews": "Se alle anmeldelser",
      "seeMore": "Se mer",
      "servicesWithName": "Hei! 👋🏻 Hvordan kan vi gi deg mer frihet i dag?",
      "startingPrice": "fra %{price} kr",
      "testimonials": "anmeldelser",
      "title": "Bestill for",
      "trainedProfessionals": "Kun opplærte fagfolk",
      "yourSafetyPriority": "Ditt sikkerhet er vår prioritet.",
      "verifiedAndTrained": "Vi sjekker og trener alle Stepapp-fagfolk"
    },
    "category": {
      "chooseYourService": "Välj din tjänst",
      "contactCustomerSupport": "Kontakta vår kundtjänstavdelning.",
      "easyOnlineBooking": "Enkel och snabb onlinebokning",
      "haveQuestions": "Har du spørsmål?",
      "liabilityInsurance": "Ansvarsforsikring opptil 1 million zł",
      "otherCategories": "Andre kategorier",
      "trainedProfessionals": "Opplærte fagfolk",
      "whatMakesUsDifferent": "Vad gör oss unika?"
    },
    "detailsForm": {
      "description": "Ditt navn og e-postadresse vil ikke være synlig for andre.",
      "title": "Fyll ut informasjonen."
    },
    "dismissBrowser": {
      "goBackToApp": "Gå tilbake til appen."
    },
    "editProfile": {
      "aboutMe": "Om meg",
      "changePhoto": "Bytt bilde",
      "title": "Rediger Profil",
      "updateInfo": "Oppdater informasjonen"
    },
    "flatSize": {
      "description": "Vi trenger å vite størrelsen på leiligheten din for å vise deg riktige priser",
      "title": "Hvor mange m2?",
      "unit": "m2"
    },
    "fullScreenNotification": {
      "reservationButtonTitle": "Se Kalender",
      "reservationDescription": "Nå kan du se dem i kalenderen din og følge fremdriften.",
      "reservationTitle": "Supert! Din reservasjon\ner akseptert."
    },
    "homeDescription": {
      "description": "Det du skriver her vil bli overført til din utfører",
      "title": "Legg til instruksjoner"
    },
    "homeEdit": {
      "addAddress": "Legg til adresse",
      "chooseFriendlyName": "Velg et vennlig navn, for eksempel: “Bestemor Gieni's Hjem”. Dette navnet er bare synlig for deg.",
      "confirmDeleteProperty": "Er du sikker på at du vil slette eiendommen?",
      "deleteProperty": "Slett eiendom",
      "editAddress": "Rediger adresse",
      "exactAddress": "Nøyaktig Adresse",
      "homeType": "Hjemmetype",
      "notEditableNote": "Du kan bare endre deler av dataene",
      "postalCode": "Postnummer",
      "provideInformation": "Gi nøyaktig adresseinformasjon slik at vi enkelt kan finne hjemmet ditt.",
      "surface": "Overflate",
      "type_APARTMENT": "Leilighet",
      "type_HOUSE": "Hus",
      "whatsImportantNote": "Hva er viktig i hjemmet ditt når det gjelder husarbeid?"
    },
    "location": {
      "description": "Vi vil sjekke om Stephome-tjenestene er tilgjengelige i ditt område",
      "title": "Skriv inn postnummeret ditt"
    },
    "login": {
      "alreadyRegistered": "Har du allerede en Stephome-konto?",
      "and": "og",
      "firstTime": "Er dette første gang hos oss?",
      "logInWithAccount": "eller logg inn på kontoen din.",
      "noAccRegister": "Har du ikke en Stephome-konto ennå! Det er på tide å ordne opp!",
      "orderFirstService": "Bestill din første tjeneste",
      "privacyPolicy": "Personvernpolicy",
      "registerTitle": "Nesten klar!\nLogg inn eller registrer deg for å legge inn bestillingen.",
      "registerYourAccount": "eller registrer en ny konto.",
      "selectingOneOfAbove": "Ved å velge en av de ovennevnte, godtar du våre",
      "social_apple": "Fortsett med Apple",
      "social_default": "Fortsett med telefonnummer",
      "social_facebook": "Fortsett med Facebook",
      "social_google": "Fortsett med Google",
      "termsOfUse": "Bruksvilkår",
      "title": "Logg inn eller registrer deg",
      "webRegisterTitle": "Nesten ferdig! Opprett en Stephome-konto eller logg inn."
    },
    "maintenance": {
      "maintenanceBreak": "Vedlikeholdspause",
      "maintenanceContactInfo": "Hvis du trenger å kontakte vår service, skriv på chatten på %{landingPageUrl} eller send en e-post til: %{supportEmail}",
      "maintenanceInProgress": "Vi gjennomfører en stor systemoppdatering, for øyeblikket er appene våre utilgjengelige."
    },
    "myHome": {
      "addInfo": "Legg til informasjon",
      "addressNote": "Legg til mer informasjon om hjemmet ditt, slik at vi bedre kan tilpasse oss til dine behov.",
      "notRegistered": "Her kan du som registrert bruker legge til informasjon om hjemmet ditt, slik at vi bedre kan forstå dine behov.",
      "st": "gate",
      "title": "Mine adresser"
    },
    "notes": {
      "addNoteToOrder": "Legg til en notat i bestillingen...",
      "cleaningNotes_cleaning": "Notater om rengjøring",
      "cleaningNotes_massage": "Notater om massasje",
      "cleaningNotes_other": "Notater om tjeneste",
      "exampleNote_cleaning": "“Jeg har steinbenkeplater på kjøkkenet”\n“Jeg har svarte skapfronter som lett får fingermerker”",
      "exampleNote_massage": "“Vennligst utfør en mildere ryggmassasje”\n“Vennligst unngå høyre kne etter operasjon”",
      "exampleNote_other": "“Vennligst vær oppmerksom på ...”",
      "notes": "Notater",
      "whatWeShouldKnow_cleaning": "Er det noe vi bør vite for å møte dine forventninger?",
      "whatWeShouldKnow_massage": "Er det noe vi bør vite før vi starter tjenesten? F.eks. liste over tidligere sykdommer osv.",
      "whatWeShouldKnow_other": "Oppgi all informasjon og instruksjoner som hjelper oss å gjennomføre tjenesten på en god måte"
    },
    "notAvailableLocation": {
      "notAvailableLocationDescription": "Våre tjenester er ikke tilgjengelige på denne adressen. Hvis du vil at vi skal komme, gi oss beskjed!",
      "notAvailableLocationTtile": "Dessverre, vi er ikke tilgjengelige på denne lokasjonen",
      "proposeCity": "Jeg vil ha Stephome i mitt område",
      "proposeCityTitle": "Jeg vil ha Stephome"
    },
    "notificationsCheck": {
      "description": "Ikke gå glipp av informasjon om kampanjer og viktige meldinger angående rengjøringen din.",
      "enableNotifications": "Aktiver varsler",
      "secondDescription": "Aktiver varsler for å motta informasjon om fremdriften av tjenesten din.",
      "secondTitle": "Ikke gå glipp av meldinger.",
      "title": "Vil du vite om rabatter?"
    },
    "oneTimePasswordForm": {
      "description": "Skriv inn koden fra SMS som vi sendte deg på %{phoneNumber}",
      "sendAgain": "Send igjen",
      "sendAgainIn": "Send igjen (%{countdown}s.)",
      "title": "Skriv inn koden fra sms"
    },
    "paymentFailed": {
      "description": "Vi kunne ikke trekke midler for å betale abonnementet ditt. Oppdater betalingsmetoden eller kontakt oss hvis du vil endre eller avbryte den.",
      "title": "Betalingsfeil"
    },
    "payments": {
      "cantRemoveCardDescription": "Du har pågående tjenester. For å fjerne kortet, betal for rengjøringen eller ta kontakt med kundeservice.",
      "cantRemoveCardTitle": "Kan ikke fjerne kortet",
      "credits": "Kreditter",
      "editPaymentInfo": "Du redigerer betalingsmetoder for spesifikke bestillinger i detaljene for den aktuelle bestillingen på 'Mine Bestillinger'-skjermen",
      "finalized": "Avsluttet",
      "noTransactions": "Ingen transaksjoner",
      "paid": "Betalt",
      "failed": "Feilet",
      "savedCards": "Lagrede kort",
      "stepappWallet": "Stephome Wallet: %{balance}",
      "title": "Betalingsmetoder",
      "transactionHistory": "Transaksjonshistorikk"
    },
    "phoneForm": {
      "description_login": "Dette er det telefonnummeret som kontoen din er registrert på Stephome",
      "description_register": "Vi trenger dette for å kunne kontakte deg angående din bestilling.",
      "title": "Oppgi ditt telefonnummer"
    },
    "pickCity": {
      "changeCity": "Endre by",
      "changeCountry": "Endre land",
      "description": "Stephome er for øyeblikket tilgjengelig i de følgende byene.",
      "loginTitle": "Velg byen du for øyeblikket bor i.",
      "registerTitle": "Velg byen du for øyeblikket bor i."
    },
    "predefinedProfile": {
      "experienceTitle": "Min erfaring...",
      "lastReviews": "Siste anmeldelser",
      "recommendationsTitle": "Om meg",
      "finishedJobs": "%{count} fullførte oppdrag",
      "customerReviews": "%{count} kundeomtaler",
      "learnMoreVerification": "Lær mer om vår verifiserings- og opplæringsprosess i Stepapp.",
      "readMore": "Les mer",
      "weCareWhoComes": "Vi bryr oss om hvem som kommer inn i ditt hjem.",
      "workerBadgeDescription_training": "%{name} har fullført vårt kurs i kvalitet, arbeidsregler og hygiene.",
      "workerBadgeDescription_safety": "%{name} er verifisert av oss og oppfyller våre sikkerhetskrav.",
      "workerBadgeTitle_training": "Opplæring",
      "workerBadgeTitle_safety": "Sikkerhet"
    },
    "profile": {
      "removeCard": "Fjern kortet",
      "removeCardExplanation": "Fjerning av kortet vil resultere i at det fjernes fra kontoen din. Det vil ikke lenger være tilgjengelig for betaling.",
      "title": "Din Profil",
      "totalOrders_zero": "%{count} bestilt jobb",
      "totalOrders_one": "%{count} bestilte jobber",
      "totalOrders_few": "%{count} bestilte jobber",
      "totalOrders_other": "%{count} bestilte jobber"
    },
    "redeemCoupon": {
      "add": "Legg til",
      "creditTitle": "Skriv inn oppladingskoden",
      "voucherTitle": "Skriv inn kampanjekoden"
    },
    "reviews": {
      "noReviews": "Vi klarte ikke å hente anmeldelser. Prøv igjen senere.",
      "numberOfReviews": "Antall anmeldelser",
      "onlyVerifiedReviews": "Kun verifiserte anmeldelser",
      "orderCleaning": "Bestill rengjøring",
      "trueReviews": "Alle våre vurderinger er gitt av ekte kunder etter utført tjeneste.",
      "star": "Stjerne",
      "star_plural": "Stjerner",
      "star_many": "Stjerner"
    },
    "service": {
      "additionalServices": "Hva mer kan vi hjelpe deg med? 🧹",
      "additionalServicesDescription": "Du kan endre frekvensen av ekstratjenester etter første bestilling.",
      "addressExplanationForVerification": "Skriv inn adressen for å verifisere tilgjengeligheten av tjenestene våre. På de neste trinnene kan du legge til mer informasjon.",
      "autocompleteInfo": "<0>Skriv inn den fullstendige gatenavnet</0> for å verifisere tilgjengeligheten av tjenestene våre. I de neste trinnene kan du legge til mer informasjon.",
      "averageCleaningTime_cleaning": "Omtrentlig rengjøringstid",
      "averageCleaningTime_massage": "Omtrentlig massasjetid",
      "averageCleaningTime_other": "Omtrentlig tjenestetid",
      "averageCleaningTimeDescription": "Dette er et omtrentlig rengjøringstidspunkt, fordi vi vet at hvert hjem er annerledes. Hvis det viser seg at mer tid vil være nødvendig på stedet, vil vi informere deg på forhånd og be om aksept.",
      "backToHome": "Tilbake til hjemmesiden",
      "changeAddress": "Endre adresse",
      "chooseAddress": "Velg adresse",
      "chooseServiceAdjustedToYourNeeds": "Velg en tjeneste tilpasset dine behov",
      "happyCustomers": "Fornøyde kunder",
      "howOften": "Hvor ofte?",
      "howOftenDescription": "Alltid den samme pålitelige personen. Prøv uten oppsigelsestid.",
      "includedInService": "Inkludert i tjenesten!",
      "loader": "Vent litt,\nvi behandler bestillingen din",
      "newAddress": "Ny adresse",
      "nextDataAddress": "Neste - dato og adresse",
      "pickOrCreateAddress": "Velg en adresse fra lagrede hjem eller legg til en ny",
      "priceForService": "Pris for tjenesten",
      "reservationError": "Ups! Noe gikk galt",
      "reservationErrorDescription": "Prøv igjen senere eller ta kontakt\nmed kundeserviceavdelingen vår",
      "reservationSuccess": "Supert! Din reservasjon\ner bekreftet",
      "reservationSuccessDescription": "Nå kan du se den i kalenderen din\nog følge med på fremdriften",
      "reviews": "Anmeldelser av Stephome",
      "seeDetails": "Se detaljer",
      "seeLastReviews": "Se Siste Anmeldelser",
      "selectAvailableOptions": "Velg tilgjengelige alternativer for å se bestillingsdetaljer",
      "serviceDateInfo": "Gratis datoendring opptil %{hours} timer før reservasjonen din starter.",
      "serviceInsurance": "Rengjøringen din er forsikret for\n%{amount}.",
      "serviceProtects": "Bestillingen beskyttes",
      "serviceRange": "Tjenesteområde",
      "showCalendar": "Se kalender",
      "showMoreServices": "Se flere tjenester",
      "subscriptionExplanationForEdit": "Husk at du senere kan endre regelmessig rengjøring.",
      "whatKindOfServiceYouNeed": "Hvilken type tjeneste trenger du?",
      "whatServiceIncludes": "Hva inkluderer tjenesten?",
      "whichAddress": "Under hvilken adresse skal vi komme?",
      "whichAddressDescription": "Velg en av de lagrede adressene eller legg til en ny."
    },
    "serviceAcceptedOverlay": {
      "thankYou": "Takk skal du ha!",
      "reviewSubmitted": "Din tilbakemelding er sendt inn. Hver kommentar hjelper oss å forbedre våre tjenester."
    },
    "serviceCalendar": {
      "chooseHour": "Velg en time som passer for deg",
      "description": "Velg dato og tidspunkt for starten av tjenesten",
      "title": "Når begynner vi?"
    },
    "serviceCard": {
      "canceled": "Avlyst",
      "details": "Detaljer",
      "rateAndAccept": "Vurder og aksepter arbeidet",
      "showProgress": "Sjekk fremdriften",
      "today": "I dag",
      "type_oneTime": "Engang",
      "type_subscription": "Abonnement",
      "worker": "Arbeider"
    },
    "serviceConfirmation": {
      "completedServicePhoto": "Tjenesten er fullført. Vi har tatt et bilde som bekrefter vår tilstedeværelse på stedet. Det er kun synlig for deg og vårt personale.",
      "doYouAcceptService": "Godtar du utførelse av tjenesten?",
      "report": "Rapporter et problem"
    },
    "serviceDetails": {
      "additionalInfo": "Ytterligere instruksjoner for leverandøren",
      "addMoreServices": "Legg til flere tjenester",
      "calendarChangeDateInfo": "Vi vil belaste deg hvis du endrer datoen for engangstjenesten mindre enn %{hoursBeforeFee} timer før den opprinnelige tiden.",
      "cancellationRule": "Du kan kansellere og redigere tjenesten opp til %{hoursBeforeFee} timer i forveien og få 100% refusjon. Kansellering etter denne tiden kan medføre ekstra kostnader.",
      "cancellationRules": "Regler for avbestilling",
      "cancelService": "Avbestill denne tjenesten",
      "changeServiceDetails_cleaning": "Endre rengjøringsdetaljer",
      "changeServiceDetails_massage": "Endre masseredetaljer",
      "changeServiceDetails_other": "Endre tjenestedetaljer",
      "changeDate": "Endre dato %{fee}",
      "changeDate2": "Endre dato",
      "changeDateInfo": "Du kan endre dato og tid for tjenesten gratis opp til %{hoursBeforeFee} timer før den reserverte tiden.",
      "changeDateIntercomMessage": "God morgen, kan jeg få endre datoen for min reservasjon fra ... til ...",
      "changeDetails": "Endre detaljer",
      "chat": "Start samtale",
      "close": "Lukk",
      "confirmDeleteService": "Er du sikker? Ekstra tjeneste vil ikke bli utført",
      "currentPrice": "Gjeldende pris",
      "deleteService": "Slette %{service}?",
      "fee": "(avgift %{fee})",
      "fetchReservationError": "Noe gikk galt under henting av detaljer for reservasjonen din. Gå tilbake til reservasjonskalenderen og prøv igjen. Hvis problemet vedvarer, kontakt oss.",
      "hour": "Time",
      "hours": "Timer",
      "manage": "Administrer",
      "newPrice": "Ny pris",
      "orderFor": "Bestilling for:",
      "paymentForm": "Betalingsmåte",
      "questionNotFound": "Kunne ikke finne spørsmålet for oppdatering",
      "questionCantBeUpdated": "Beklager, men dette svaret kan ikke lenger endres. For å gjøre endringer, vennligst kontakt kundestøtte.",
      "service": "Tjeneste",
      "showCancellationRules": "Se våre avbestillingsregler",
      "submitChangeConfirmation": "Tjenestetidspunktet er lagret!",
      "submitChangeLoader": "Vent litt, vi lagrer endringene",
      "submitDetailsConfirmation": "Endringene i tjenesten er lagret",
      "subscriptionChangeDateInfo": "Abonnenter har fleksibilitet! For rengjøring som en del av abonnementet, kan du gjøre endringer gratis opptil 36 timer før tjenesten!",
      "total": "Totalt",
      "totalPaymentInfo": "Vi vil belaste betalingen først på rengjøringsdagen, men midlene vil bli reservert 48 timer før avtalt tidspunkt.",
      "type_oneTime": "Engangs",
      "type_subscription": "Abonnement",
      "writeToUs": "skriv til oss"
    },
    "serviceRating": {
      "addPublicReview": "Legg igjen en offentlig anmeldelse",
      "answersNotShared": "Svarene vil ikke bli delt med arbeideren.",
      "asYourWorker": "som din arbeider?",
      "cleanLeaveRating": "Rent? Gi en vurdering!",
      "doYouWantToKeep": "Vil du beholde",
      "enterText": "Skriv inn tekst",
      "followedInstructions": "Følgte arbeideren dine instruksjoner?",
      "giveYouComment": "Gi oss din kommentar",
      "howDoYouRateYourExperience": "Hvordan vil du vurdere din opplevelse?",
      "keep": "Behold",
      "leaveOpinion": "Legg igjen mening",
      "leaveOpinionAndRating": "Del din mening og vurder tjenesten.",
      "leaveRating": "Legg igjen vurdering",
      "newWorker_description": "Du vil se en ny arbeider 48 timer før neste tjeneste",
      "newWorker_title": "OK, vi vil tildele noen andre til neste tjeneste",
      "optional": "Valgfritt",
      "rating1": "Dårlig kvalitet på tjenesten",
      "rating2": "Dårlig",
      "rating3": "Tjenesten innfridde ikke mine forventninger",
      "rating4": "Det var OK, men kan forbedres",
      "rating5": "Tjenesten oppfylte mine forventninger 100%",
      "sorryToHearThat": "Beklager å høre det.",
      "touchStarsToLeaveReview": "Trykk på stjernene for å legge igjen en anmeldelse.",
      "wasOnTime": "Var arbeideren på tide?",
      "wasPrepared": "Var arbeideren forberedt for jobben?",
      "wantTheSameWorkerAgain": "Vil du ha den samme arbeideren igjen?"
    },
    "serviceRealization": {
      "chat": "Chat",
      "checkAndConfirm": "Sjekk og bekreft resultater",
      "daysLeft": "%{daysLeft} dag igjen",
      "daysLeft_plural": "%{daysLeft} dager igjen",
      "info": "Info",
      "rateTheServiceWithin": "Vurder tjenesten innen 7 dager",
      "report": "Rapporter",
      "serviceCompleted": "Tjenesten utført!",
      "serviceStatus": "Tjenestestatus",
      "statusChoosen": "Arbeideren er valgt",
      "statusChoosenDescription": "Vi har valgt en person til å utføre tjenesten hjemme hos deg! For abonnementstjenester vil det alltid være den samme personen!",
      "statusInProgress": "Pågående tjeneste",
      "statusInProgressDescription": "Arbeideren jobber allerede med rengjøringen! Når rengjøringen er ferdig, vil vi be om tilbakemelding fra deg!",
      "statusOnTheWay": "Arbeideren er på vei",
      "statusOnTheWayDescription": "Det skjer i dag! Snart vil arbeideren komme for å friske opp hjemmet ditt!",
      "statusWaitingForAccpetance": "Din bestilling er fullført!",
      "still": "fortsatt"
    },
    "serviceSummary": {
      "addCreditDebitCard": "Legg til kreditt- eller debetkort",
      "additionalServices": "Tilleggstjenester",
      "cardPayment": "Kortbetaling",
      "changeCoupon": "Endre kupong",
      "changeDate": "Endre dato",
      "confirmAndOrder": "Bekreft og betal",
      "choosePaymentMethod": "Velg betalingsmetode",
      "coupon": "Kupong \"%{coupon}\"",
      "description": "Gjennomgå bestillingen din igjen og sjekk om alt stemmer",
      "enterCoupon": "Skriv inn kupong",
      "frequency_EVERY_MONTH": "Hver måned",
      "frequency_EVERY_TWO_WEEKS": "Hver annenhver uke",
      "frequency_EVERY_WEEK": "Hver uke",
      "frequency_ONE_TIME": "En gang",
      "grossPriceIncludingVAT": "Prisen ovenfor er bruttoprisen, som inkluderer MVA %{vat}%",
      "howOften": "Hvor ofte?",
      "importantInformation": "Viktig informasjon",
      "iWillBeThere": "Jeg vil være der",
      "logIn": "Logg inn",
      "loginToViewDetails": "Logg inn eller registrer deg for å legge inn bestillingen",
      "orderingFor": "Bestiller for",
      "orderingForDescription": "Oppgitte opplysninger vil bli lagret i profilen som 'Min adresse'",
      "paidOnServiceDay": "Betaling på tjenestedagen",
      "paymentMethod": "Betalingsmetode",
      "paymentNotice": "Etter at du har lagt inn bestillingen, vil vi utføre en verifikasjonsbetaling tilsvarende bestillingsbeløpet. Dette beløpet vil bli refundert innen maksimalt 10 minutter. Den faktiske reservasjonsavgiften belastes først etter at tjenesten er fullført.",
      "paymentNow": "Betal nå",
      "paymentNowInfo": "Ved bestilling med utførelse innen 48 timer, blokkerer vi midlene ved bestillingstidspunktet.",
      "paymentTerms": "Betalingsvilkår er tilgjengelige på %{link}",
      "recurringPayment": "Gjentakende betalinger",
      "registerAndOrder": "Registrer deg og bestill",
      "sendSMSCode": "Send SMS-kode",
      "SMSInfo": "Vi sender en SMS-kode til det oppgitte telefonnummeret. Skriv den inn for å bekrefte pålogging eller registrering.",
      "subscriptionDiscount": "Abonnementsrabatt",
      "title": "Oppsummering",
      "toPay": "Å betale",
      "total": "Totalt",
      "usedVoucher": "Brukt kupong",
      "wantEnterCoupon": "Ønsker du å legge til en kupong?",
      "webCardModalTitle": "Dette er siste steg. Legg til kortet og nyt et rent hjem. 🏠",
      "webPaymentInfo": "Din personlige data administreres av Stephome Sp. z.o.o. Betalingsadministratoren er Stripe. Vi vil aldri trekke penger uten ditt forhåndssamtykke, og du har 7 dagers reklamasjonsrett på alle transaksjoner.",
      "whatIfSomethingsGoesWrong": "Hva om noe går galt?",
      "whatIfSomethingsGoesWrongDescription": "Hvis du ikke er fornøyd med tjenesten, garanterer vi at den vil bli utført på nytt av de mest erfarne personene i teamet vårt. Selvfølgelig uten kostnad.",
      "whatNow": "Hva nå?",
      "whatNowDescription": "Etter at din bestilling er bekreftet, vil vi matche deg med den beste leverandøren i området basert på dine preferanser. Du vil bli kjent med dem og kunne kontakte dem 48 timer før oppdraget starter.",
      "when": "Når?",
      "yourCardWillBeLinkedTo": "Kortet ditt vil bli knyttet til Stephome-kontoen din og brukt til fremtidige nedlastinger av bestilte tjenester. Du kan alltid endre det i innstillingene.",
      "yourDataIsSecureThanksTo": "Dine data er sikre takket være",
      "yourDataIsSecureThanksToStripe": "Dine data er sikre takket være Stripe Ltd.",
      "yourStepappWallet": "Din Stephome-lommebok"
    },
    "settings": {
      "accountDeleted": "Konto slettelsesprosessen er startet. Vi må sjekke om du har noen utestående transaksjoner. Kontoen din og all tilknyttet data vil bli slettet innen 7 dager.",
      "cancellationRules": "Avbestillingsregler",
      "deleteAccount": "Slett konto",
      "discountsAndPromotions": "F.eks. rabatter, tilbud og kampanjer",
      "email": "E-postadresse",
      "logOut": "Logg ut",
      "notifications": "Varsler",
      "newsletterAndPromotions": "Nyhetsbrev og kampanjer",
      "others": "Andre",
      "phoneNumber": "Telefonnummer",
      "privacyPolicy": "Personvernregler",
      "pushNotifications": "Pushvarsler i appen",
      "informationAboutReservation": "Inkluderer: informasjon om dine reservasjoner, meldinger fra kundeservice",
      "reminderAboutReservation": "Inkluderer: påminnelser om reservasjoner, viktige meldinger fra kundeservice",
      "removeAccountExplanation": "Din konto vil bli slettet. Denne handlingen kan ikke angres.",
      "smsNotifications": "SMS-varsler",
      "title": "Innstillinger",
      "updateEmailAddress": "Oppdater e-postadresse",
      "wantToChangePhoneNumber": "Hvis du vil endre telefonnummeret ditt,"
    },
    "support": {
      "call": "Ring",
      "contactOptions": "Kontaktalternativer:",
      "sendEmail": "Send e-post",
      "startChat": "Start chat",
      "title": "Kontakt oss"
    },
    "unmatched": {
      "description": "Vi kan ikke finne siden du leter etter. Prøv å gå tilbake til forrige side eller kontakt oss for mer informasjon.",
      "title": "Oops,\nher er det ingenting..."
    },
    "welcome": {
      "customerSupportDescription": "Vi er tilgjengelige for deg 7 dager i uken via chat og e-post, og vil svare på ethvert problem som du ikke kan løse via appen.",
      "customerSupportTitle": "Kundeservice alltid tilgjengelig.",
      "letsStart": "La oss begynne!",
      "orderCleaningDescription": "Få en prisvurdering for rengjøring av hjemmet ditt, velg en tilgjengelig tid og bestill tjenesten når som helst, 24/7.",
      "orderCleaningTitle": "Enkel og rask måte å bestille rengjøring på.",
      "trustedTeamDescription": "Hver rengjøringspersonell hos Stephome har blitt sjekket under flere dagers opplæring og rengjør i henhold til spesifikke regler og standarder.",
      "trustedTeamTitle": "Pålitelig, erfaren og opplært team."
    }
  },
  "validation": {
    "address": "Vennligst oppgi riktig adresse",
    "blank": "Dette feltet kan ikke være tomt",
    "city": "Vennligst oppgi riktig bynavn",
    "companyName": "Vennligst oppgi firmanavnet",
    "date": "Velg tjenestedato",
    "email": "Vennligst oppgi riktig e-postadresse",
    "firstName": "Vennligst oppgi ditt fornavn",
    "homeType": "Velg boligtype",
    "hour": "Velg tjenestetidspunkt",
    "invalid": "Vennligst oppgi riktige data",
    "keyInfo": "Beskriv hvor du vil legge igjen nøkkelen",
    "lastName": "Vennligst oppgi ditt etternavn",
    "maxSurface": "Den maksimalt støttede arealet er %{maxSize}m2",
    "minSurface": "Minimum støttet overflate er %{minSize}m2",
    "nipNumber": "Vennligst oppgi riktig NIP-nummer",
    "numberOrHousing": "Vennligst oppgi husnummer/leilighetsnummer",
    "phone": "Vennligst oppgi riktig telefonnummer",
    "pickAddress": "Velg adresse",
    "pickOption": "Velg ett av alternativene",
    "postalCode": "Vennligst oppgi riktig postnummer",
    "required": "Påkrevd",
    "smsOrPhoneNumber": "Feil SMS-kode eller telefonnummer"
  },
  "verification": {
    "closePage": "Denne siden vil lukke automatisk om 10 sekunder",
    "paymentVerificationConfirmed": "Din betaling er bekreftet",
    "paymentVerificationFailed": "Bekreftelsen mislyktes",
    "retryVerification": "Prøv igjen eller bruk en annen betalingsmetode."
  }
}
